import { Component, ElementRef } from '@angular/core';

@Component({
  selector: 'app-fullscreen-div',
  templateUrl: './fullscreen-div.component.html',
  styleUrls: ['./fullscreen-div.component.scss']
})
export class FullscreenDivComponent {

  isFullscreen: boolean = false;
  constructor(private elementRef: ElementRef) { }

  toggleFullscreen() {
    if (!this.isFullscreen) {
      this.openFullscreen();
    } else {
      this.closeFullscreen();
    }
    this.isFullscreen = !this.isFullscreen;
  }

  openFullscreen() {
    var docElm = document.querySelector('body');
    if (docElm) {

      if (docElm.requestFullscreen) {

        docElm.requestFullscreen();
      }
    }



    /*  let elem = this.elementRef.nativeElement.querySelector('.fullscreen');
  
     if (elem.requestFullscreen) {
       elem.requestFullscreen();
     } else if (elem.webkitRequestFullscreen) { 
       elem.webkitRequestFullscreen();
     } else if (elem.msRequestFullscreen) { 
       elem.msRequestFullscreen();
     } */
  }

  closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }


}
